import { AutoCloseContextProvider } from '../AutoCloseContext';
import { CallbackContextProvider } from './CallbackContextProvider';
import { TranslationInitBoundary } from '../hoc/TranslationInitBoundary';
import I18NProvider from './I18NProvider';
import { StoreProvider } from '../../app/provider';
import { BankAppConfiguration } from '../../types/sdk';
import { ReactNode } from 'react';
import CustomizationsProvider, { CustomizationState } from '../../contexts/CustomizationsContext';

type Props = {
	configuration: BankAppConfiguration;
	customizations: CustomizationState;
	children: ReactNode;
};

export const AppAggregateProvider = ({ configuration, customizations, children }: Props) => {
	const callbacks = configuration.callbacks;

	return (
		<StoreProvider configuration={configuration}>
			<CustomizationsProvider initialCustomizations={customizations}>
				<CallbackContextProvider callbacks={callbacks}>
					<AutoCloseContextProvider>
						<TranslationInitBoundary>
							<I18NProvider>{children}</I18NProvider>
						</TranslationInitBoundary>
					</AutoCloseContextProvider>
				</CallbackContextProvider>
			</CustomizationsProvider>
		</StoreProvider>
	);
};
